export default __webpack_public_path__ + "static/media/Heat Wave 225d4541dfed491f87eafad33ec0207a.5025a47a.md";